import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

export const selectFileData = (state) => get('files', state);

export const selectFiles = createSelector(selectFileData, (files) => files.files);
